import { z } from 'zod'

/**
 * Where a placeable furniture item in an event plan comes from:
 * - `venue` — the venue's own stock (inventory),
 * - `client` — brought in by the client/planner ("Add your own"),
 * - `vendor` — supplied by a third-party vendor approved for that venue.
 *
 * This is a computed wire enum (not stored in Prisma): the API derives it when
 * assembling a phase's availability, and the planner groups the picker by it.
 */
export const FURNITURE_SOURCES = ['venue', 'client', 'vendor'] as const

export const furnitureSourceSchema = z.enum(FURNITURE_SOURCES)

export type FurnitureSource = z.infer<typeof furnitureSourceSchema>
